import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import FundraisingAddAmbassadorForm from 'src/components/Forms/Fundraising/FundraisingAddAmbassadorForm';

const AddAmbassadorModal = () => (
  <ModalBase
    name={MODALS.addAmbassador}
    size={MODALS_SIZE.small}>
    <FundraisingAddAmbassadorForm />
  </ModalBase>
);

export default AddAmbassadorModal;
